<template>
  <app-retelling v-bind="$attrs" title="Custom" />
</template>
<script>
import Retelling from "./Retelling.vue";
export default {
  components: {
    appRetelling: Retelling,
  },
};
</script>
